import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleInput, SingleText } from '../../Res/BaseInput';
import { SubmitButton, CancelButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { getUserInfo, getval2Token } from '../../../Login/Auth';
import moment from 'moment';
import { getOnlyDate } from '../../../../item/ItemTools';
import { ReqRecruitmentContractorCaseInfo, CASE_STATUS_RESIGN, RespRecruitmentContractorDetail, CASE_STATUS_RESERVE, CASE_STATUS_RESERVE_STRING, CASE_STATUS_ONBOARD, CASE_STATUS_CANCEL, CASE_STATUS_ONBOARD_STRING, CASE_STATUS_CANCEL_STRING, CASE_STATUS_RESIGN_STRING, ReqCaseInfoText, CASE_STATUS_CANCEL_SHORT_STRING, CASE_STATUS_ONBOARD_SHORT_STRING } from '../../../../item/ItemRecruitmentContractor';
import { api_updateRecruitmentContractor } from '../../../../api/apiRecruitmentContractor';
import { api_getRecruitmentPerformanceContractorRelatedDetail } from '../../../../api/apiRecruitmentPerformanceContractorRelated';
import { ReqRecruitmentContractorDetail } from '../../../../item/ItemRecruitmentPerformanceContractorRelated';


export function IsOrNotOnboardSOP({ id, setIsLoading }) {
  const [tokenId, setTokenId] = useState("")
  const [recruitmentContractorId, setRecruitmentContractorId] = useState("")
  const [companyId, setCompanyId] = useState("")
  const [departmentId, setDepartmentId] = useState()
  const [customerContractId, setCustomerContractId] = useState("")
  const [customerPositionId, setCustomerPositionId] = useState("")

  const [userInfo] = useState(getUserInfo())
  const [detail, setDetail] = useState(new RespRecruitmentContractorDetail({}))

  const [caseContractor, setCaseContractor] = useState("")

  const [caseStatus, setCaseStatus] = useState(0)
  const [caseStatusString, setCaseStatusString] = useState("")

  const [caseCreateDate, setCaseCreateDate] = useState()
  const [caseReserveDate, setCaseReserveDate] = useState()
  const [caseCancelDate, setCaseCancelDate] = useState()
  const [caseOnBoardDate, setCaseOnBoardDate] = useState()
  const [caseResignDate, setCaseResignDate] = useState()

  const [caseOwner, setCaseOwner] = useState("")
  const [caseOwnerName, setCaseOwnerName] = useState("")

  const [caseContractorName, setCaseContractorName] = useState("")
  const [caseSexAge, setCaseSexAge] = useState("")
  const [caseMobile, setCaseMobile] = useState("")
  const [caseSignAt, setCaseSignAt] = useState("")
  const [caseCompanyName, setCaseCompanyName] = useState("")
  const [caseCustomerPosition, setCaseCustomerPosition] = useState("")
  const [caseWorkPlace, setCaseWorkPlace] = useState("")
  const [caseWorkAddress, setCaseWorkAddress] = useState("")
  const [caseProcessDescription, setCaseProcessDescription] = useState([])
  const [caseComment, setCaseComment] = useState([])

  const [comment, setComment] = useState("")
  const [processDescription, setProcessDescription] = useState("")

  const [isClosed, setIsClosed] = useState(0)
  const [isDelete, setIsDelete] = useState(0)
  const [creatAccountId, setCreatAccountId] = useState("")
  const [creatAt, setCreatAt] = useState("")

  const [laborInsuranceStatusCode, setLaborInsuranceStatusCode] = useState("0") //勞保狀態參數
  const [laborPensionStatusCode, setLaborPensionStatusCode] = useState("0")     //勞退狀態參數
  const [healthInsuranceStatusCode, setHealthInsuranceStatusCode] = useState("0") //健保狀態 參數
  const [groupInsuranceStatusCode, setGroupInsuranceStatusCode] = useState("0")     //團保狀態參數

  const [laborInsuranceType, setLaborInsuranceType] = useState("0")
  const [laborInsuranceLevel, setLaborInsuranceLevel] = useState("0")
  const [healthInsuranceLevel, setHealthInsuranceLevel] = useState("0")


  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var rId = getval2Token("recruitmentContractorId", id)
      setRecruitmentContractorId(rId)
      var mReqRecruitmentContractorDetail = new ReqRecruitmentContractorDetail({
        recruitmentContractorId: rId,
      })
      getDetail(mReqRecruitmentContractorDetail)
    }
  }, [id])


  function getDetail(mReqRecruitmentContractorDetail) {
    setIsLoading(true)
    console.log(mReqRecruitmentContractorDetail)
    api_getRecruitmentPerformanceContractorRelatedDetail({
      mReqRecruitmentContractorDetail,
      success: (result) => {
        // console.log(result)
        var mRespRecruitmentContractorDetail = new RespRecruitmentContractorDetail({})
        mRespRecruitmentContractorDetail.fromJson(result.detail)
        // console.log(mRespRecruitmentContractorDetail)
        setDetail(mRespRecruitmentContractorDetail)
        setCompanyId(mRespRecruitmentContractorDetail.companyId)
        setDepartmentId(mRespRecruitmentContractorDetail.departmentId)
        setCaseContractor(mRespRecruitmentContractorDetail.caseContractor)
        setCaseContractorName(mRespRecruitmentContractorDetail.caseContractorName)

        var sex = mRespRecruitmentContractorDetail.caseContractorSex === "1" ? "男" : mRespRecruitmentContractorDetail.caseContractorSex === "2" ? "女" : ""
        var age = mRespRecruitmentContractorDetail.caseContractorAge
        setCaseSexAge(sex + "/" + age)
        // console.log(mRespRecruitmentContractorDetail.caseContractorMobile)
        setCaseMobile(mRespRecruitmentContractorDetail.caseContractorMobile)
        setCaseStatus(mRespRecruitmentContractorDetail.caseStatus)
        var statusString = ""
        switch (mRespRecruitmentContractorDetail.caseStatus) {
          case CASE_STATUS_RESERVE:
            statusString = CASE_STATUS_RESERVE_STRING + " "
              + moment(mRespRecruitmentContractorDetail.caseInfo.caseReserveDate).format('YYYY/MM/DD')
            break;
          case CASE_STATUS_ONBOARD:
            statusString = CASE_STATUS_ONBOARD_STRING + " "
              + moment(mRespRecruitmentContractorDetail.caseInfo.caseOnBoardDate).format('YYYY/MM/DD')
            break;
          case CASE_STATUS_CANCEL:
            statusString = CASE_STATUS_CANCEL_STRING + " "
              + moment(mRespRecruitmentContractorDetail.caseInfo.caseCancelDate).format('YYYY/MM/DD')
            break;
          case CASE_STATUS_RESIGN:
            statusString = CASE_STATUS_RESIGN_STRING + " "
              + moment(mRespRecruitmentContractorDetail.caseInfo.caseResignDate).format('YYYY/MM/DD')
            break;
          default:
            break;
        }
        setCaseStatusString(statusString)

        setIsClosed(mRespRecruitmentContractorDetail.isClosed)
        setIsDelete(mRespRecruitmentContractorDetail.isDelete)
        setCaseOwner(mRespRecruitmentContractorDetail.caseOwner)
        setCaseOwnerName(mRespRecruitmentContractorDetail.caseOwnerName)
        setCreatAccountId(mRespRecruitmentContractorDetail.creatAccountId)
        setCreatAt(mRespRecruitmentContractorDetail.creatAt)

        // console.log(mRespRecruitmentContractorDetail.caseInfo.customerPositionId)
        setCustomerPositionId(mRespRecruitmentContractorDetail.caseInfo.customerPositionId)
        setCaseCreateDate(mRespRecruitmentContractorDetail.caseInfo.caseCreateDate)
        setCaseReserveDate(mRespRecruitmentContractorDetail.caseInfo.caseReserveDate)
        setCaseCompanyName(mRespRecruitmentContractorDetail.caseInfo.caseCompanyName)
        setCaseSignAt(mRespRecruitmentContractorDetail.caseInfo.caseSignAt)
        setCaseCustomerPosition(mRespRecruitmentContractorDetail.caseInfo.caseCustomerPosition)
        setCaseWorkPlace(mRespRecruitmentContractorDetail.caseInfo.caseWorkPlace)
        setCaseWorkAddress(mRespRecruitmentContractorDetail.caseInfo.caseWorkAddress)
        setCaseProcessDescription(mRespRecruitmentContractorDetail.caseInfo.caseProcessDescription)
        setCaseComment(mRespRecruitmentContractorDetail.caseInfo.caseComment)
        setCaseCancelDate(mRespRecruitmentContractorDetail.caseInfo.caseCancelDate)
        setCaseOnBoardDate(mRespRecruitmentContractorDetail.caseInfo.caseOnBoardDate)
        setCaseResignDate(mRespRecruitmentContractorDetail.caseInfo.caseResignDate)
        setIsLoading(false)
      },
      failure: (err) => {
        //console.log(err)
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err.message,
        }).then(() => {
          window.history.go(-1)
        })
      }
    })
  }

  function setReqRecruitmentContractorCaseInfo(caseInfoText) {
    var cp = caseProcessDescription
    cp.push(new ReqCaseInfoText({ id: caseOwner, name: caseOwnerName, text: getOnlyDate() + " "+ caseInfoText}))
    var cc = caseComment
    if (comment !== "")
      cc.push(new ReqCaseInfoText({ id: caseOwner, name: caseOwnerName, text: comment }))
    var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({
      caseCreateDate,
      caseReserveDate,
      customerPositionId,
      // caseContractorName,
      // caseSexAge,
      // caseMobile,
      caseSignAt,
      caseCompanyName,
      caseWorkPlace,
      caseWorkAddress,
      caseCustomerPosition,
      caseProcessDescription: cp,
      caseComment: cc,
    })
    return mReqRecruitmentContractorCaseInfo
  }
  function setRespRecruitmentContractorDetail(mReqRecruitmentContractorCaseInfo) {
    var mRespRecruitmentContractorDetail = new RespRecruitmentContractorDetail({
      recruitmentContractorId,
      companyId,
      departmentId,
      caseContractor,
      caseStatus: CASE_STATUS_RESERVE,
      caseInfo: JSON.stringify(mReqRecruitmentContractorCaseInfo),
      isClosed,
      isDelete,
      caseOwner,
      caseOwnerName,
      creatAccountId,
      creatAt
    })
    mRespRecruitmentContractorDetail.caseOwnerName = caseOwnerName
    //console.log(mRespRecruitmentContractorDetail)
    return mRespRecruitmentContractorDetail
  }

  function checkCaseOwner(){
    if(userInfo.accountId === caseOwner){
      return true
    }
    return false
  }

  function cantAction(){
    Swal.fire({
      type: 'error',
      title: '提醒',
      text: "需案件擁有者才可操作",
    }).then(() => {
    })
  }
  

  function toCaseCancel() {
    if(!checkCaseOwner()){
      cantAction()
      return
    }
    setIsLoading(true)
    var mReqRecruitmentContractorCaseInfo = setReqRecruitmentContractorCaseInfo(CASE_STATUS_CANCEL_SHORT_STRING)
    mReqRecruitmentContractorCaseInfo.caseCancelDate = getOnlyDate()
    console.log(mReqRecruitmentContractorCaseInfo)
    var mRespRecruitmentContractorDetail = setRespRecruitmentContractorDetail(mReqRecruitmentContractorCaseInfo)
    //console.log(mRespRecruitmentContractorDetail)
    mRespRecruitmentContractorDetail.caseStatus = CASE_STATUS_CANCEL

    //console.log(mRespRecruitmentContractorDetail)
    updateRecruitmentContractor(mRespRecruitmentContractorDetail, '設定為未報到')
  }

  function toCancel() {
    window.history.go(-1)
  }

  function toCaseOnBoard() {
    if(!checkCaseOwner()){
      cantAction()
      return
    }
    const reserveDate = moment(caseReserveDate)
    const nowDate = moment(moment(new Date()).format("YYYY-MM-DD"))
    // let tomorrow  = moment(moment(new Date()).add(1,'days').format("YYYY-MM-DD"))
    const diffDate = nowDate.diff(reserveDate, 'days');
    // console.log(reserveDate)
    // console.log(tomorrow)
    console.log(diffDate)
    if (diffDate > 1 || diffDate < 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: "預訂上工日當日及次日，才能進行報到作業！",
      }).then(() => {
      })
      return
    }
    setIsLoading(true)
    var mReqRecruitmentContractorCaseInfo = setReqRecruitmentContractorCaseInfo(CASE_STATUS_ONBOARD_SHORT_STRING)
    mReqRecruitmentContractorCaseInfo.caseOnBoardDate = getOnlyDate()
    //console.log(mReqRecruitmentContractorCaseInfo)
    var mRespRecruitmentContractorDetail = setRespRecruitmentContractorDetail(mReqRecruitmentContractorCaseInfo)
    mRespRecruitmentContractorDetail.caseStatus = CASE_STATUS_ONBOARD

    console.log(mRespRecruitmentContractorDetail)
    updateRecruitmentContractor(mRespRecruitmentContractorDetail, '設定為已報到')
  }

  function updateRecruitmentContractor(mRespRecruitmentContractorDetail, title) {
    api_updateRecruitmentContractor({
      mRespRecruitmentContractorDetail,
      success: (jsonData) => {
        console.log(jsonData)
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title,
        }).then(() => {
          window.history.go(-1)
        })
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  var title = <>
    <span className="text-primary">報到/未報到 作業：</span>
    <span className="text-success">{caseContractorName}</span>
    <span className="text-primary">預定的工作狀態</span>
  </>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"工作狀態"} val={caseStatusString} />
          <SingleText title={"性別/年齡"} val={caseSexAge} />
          <SingleText title={"手機號碼"} val={caseMobile} />
          <SingleText title={"本次預定專員"} val={caseOwnerName} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"合約廠商"} val={caseSignAt + " " + caseCompanyName} />
          <SingleText title={"職缺"} val={caseCustomerPosition} />
          <SingleText title={"工作地點"} val={caseWorkPlace} />
          <SingleText title={"工作地址"} val={caseWorkAddress} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"勞保狀態"} val={"加保中、2019/12/25、28,800"} />
          <SingleText title={"勞退狀態"} val={"已退保、2019/12/25、28,800"} />
          <SingleText title={"健保狀態"} val={"已退保、2019/12/25、28,800"} />
          <SingleText title={"團保保狀態"} val={"N/A"} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"本次作業的評論/備註"} val={comment} action={setComment} placeholder={"請儘量簡短"} size={6} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-2">
            <p>親愛的招募人員請注意</p>
          </div>
          <div className="col-md-10">
            <strong>1.“上工日期”=“加保日期”！若不小心誤植，請找您的主管協助處理。<p></p>
              2.如果"上工日期"與此次"預定日期"不同，請重做“預定作業”，再進行“報到”。 <p></p>
              3. 請再三確認外派員工“已上工”，再按下“確定已報到”。不然會有“不可逆”的後果。<p></p>

            </strong>
          </div>
        </div>
      </div>
    </>
  var footer =
    <div className="row text-right ">
      <div className="col-sm-12">
        <SubmitButton name={"確定未報到"} action={toCaseCancel} />
        <CancelButton action={toCancel} />
        <SubmitButton action={toCaseOnBoard} name={"確定已報到"} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    </>
  )
}

